"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _ClickAwayListener = _interopRequireDefault(require("@mui/material/ClickAwayListener"));
var _Popper = _interopRequireDefault(require("../../Popper"));
var _makeStylesInternal = _interopRequireDefault(require("../../makeStyles/makeStylesInternal"));
var _tokens = require("./../../styles/tokens");
var _propTypes = _interopRequireDefault(require("prop-types"));
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var useStyles = (0, _makeStylesInternal.default)(function () {
  return {
    paperRoot: {
      boxShadow: "\n            0 0.1875rem 0.3125rem -0.0625rem rgba(0,0,0,0.2),\n            0 0.3125rem " + _tokens.spacing30 + " 0 rgba(0,0,0,0.14),\n            0 0.0625rem 0.875rem 0 rgba(0,0,0,0.12)\n        "
    }
  };
});
var CAL_EVENT_CLASS = 'calendar-event';
var CalendarEvent = function CalendarEvent(props) {
  var classes = useStyles();
  var eventRef = (0, _react.useRef)(null);
  var _useState = (0, _react.useState)(null),
    anchorEl = _useState[0],
    setAnchorEl = _useState[1];
  var _useState2 = (0, _react.useState)(false),
    localOpen = _useState2[0],
    setLocalOpen = _useState2[1];
  var open = props.open,
    target = props.target,
    popperContent = props.popperContent,
    event = props.event,
    popperOpen = props.popperOpen;
  var title = /*#__PURE__*/_react.default.createElement("span", null, event.title);
  var closePopperOnKey = function closePopperOnKey(_ref) {
    var key = _ref.key;
    if (key === 'Escape') {
      setLocalOpen(false);
    }
  };
  (0, _react.useEffect)(function () {
    target && setLocalOpen(target.querySelector("." + CAL_EVENT_CLASS).dataset.id === "" + event.event.id);
  }, [event, target]);
  (0, _react.useEffect)(function () {
    // we want the anchor on the event as a whole, rather than just the label
    // this could / should be moved to logic within the EventWrapper, but that would require a refactor
    popperContent && setAnchorEl(eventRef.current.closest('.rbc-event'));
    document.addEventListener('keydown', closePopperOnKey);
    return function () {
      document.removeEventListener('keydown', closePopperOnKey);
    };
  }, [popperContent]);
  if (!popperContent) {
    return title;
  }
  var closePopper = function closePopper() {
    setLocalOpen(false);
    // tell calendar that we closed the popper by the ClickAwayListener
    popperOpen(false);
  };
  return /*#__PURE__*/_react.default.createElement("div", {
    className: CAL_EVENT_CLASS + " " + CAL_EVENT_CLASS + "-" + event.event.id,
    "data-id": event.event.id,
    ref: eventRef
  }, title, /*#__PURE__*/_react.default.createElement(_ClickAwayListener.default, {
    onClickAway: function onClickAway() {
      return closePopper();
    }
  }, /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_Popper.default, {
    className: CAL_EVENT_CLASS + "-popper",
    classes: {
      paperRoot: classes.paperRoot
    },
    arrow: true,
    open: localOpen && open,
    anchorEl: anchorEl,
    modifiers: [{
      name: 'flip',
      options: {
        altBoundary: true
      }
    }],
    placement: "top"
  }, typeof popperContent === 'function' ? popperContent(event.event) : popperContent))));
};
CalendarEvent.displayName = 'CalendarEvent';
CalendarEvent.propTypes = {
  event: _propTypes.default.object,
  target: _propTypes.default.object,
  open: _propTypes.default.bool,
  popperContent: _propTypes.default.oneOfType([_propTypes.default.node, _propTypes.default.func]),
  popperOpen: _propTypes.default.func
};
var _default = CalendarEvent;
exports.default = _default;